module.exports = __webpack_public_path__ + "img/数字验证码.b46b8f09.png";